import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import ActionBar from "./components/ActionBar";
import ContentLayout from "./components/ContentLayout";
import StatCards from "./components/StatCards";
import {
  getMockVehicleDetail,
  MOCK_STAT_CARDS,
  MOCK_VEHICLES,
} from "./data";
import { vehicleStatusesSaga } from "./redux/saga";
import { actions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const VechileStatuses = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });
  useInjectSaga({ key: sliceKey, saga: vehicleStatusesSaga });

  useEffect(() => {
    dispatch(actions.getListSuccess(MOCK_VEHICLES));
    dispatch(actions.setStatCards(MOCK_STAT_CARDS));

    const firstVehicle = MOCK_VEHICLES[0];
    if (firstVehicle) {
      dispatch(
        actions.getVehicleDetailSuccess({
          vehicleId: firstVehicle.id,
          detail: getMockVehicleDetail(firstVehicle),
        })
      );
    }
  }, [dispatch]);

  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb
              title={t("SIDEBAR.VEHICLE_STATUS")}
              iconPosition="end"
            />
            <StatCards />
            <ActionBar />
            <ContentLayout />
          </Box>
        </Box>
    </Box>
  );
};

export default VechileStatuses;
